/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { FormGroup, FormGroupDirective } from '@angular/forms';
import { Input, Directive } from '@angular/core';
import { BaseForm } from './base-form';

@Directive()
export abstract class ChildForm<T> extends BaseForm<T> {
  form: FormGroup | undefined = undefined;
  protected parentForm: FormGroup | undefined = undefined;

  protected constructor(protected formGroupDirective: FormGroupDirective) {
    super();
  }

  private _controlName: string | undefined = undefined;

  @Input()
  set controlName(value: string) {
    this._controlName = value;
    if (this._controlName) {
      this.parentForm = this.formGroupDirective.form;
      this.form = this.createForm();
      this.parentForm.addControl(this._controlName, this.form);
    }
  }
}
